import { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { AccountLayout } from "@/components/candidate/AccountLayout";
import { apiFetch, formatDate, StatusPill } from "@/components/candidate/shared";

export default function CandidateApplications() {
    const [apps, setApps] = useState(null);

    useEffect(() => {
        apiFetch("/candidate/applications")
            .then((r) => (r.ok ? r.json() : []))
            .then(setApps)
            .catch(() => setApps([]));
    }, []);

    return (
        <AccountLayout title="My Applications" subtitle="Every application you've submitted, with its current status.">
            {apps === null ? (
                <div className="h-6 w-6 animate-spin rounded-full border-2 border-forest border-t-transparent" />
            ) : apps.length === 0 ? (
                <p data-testid="applications-empty" className="border-t border-ink/10 py-16 text-center text-sm text-ink/50">
                    No applications yet — <a href="/jobs" className="font-medium text-forest">browse open roles</a> and apply.
                </p>
            ) : (
                <div data-testid="candidate-applications-list">
                    {apps.map((app) => (
                        <a
                            key={app.id}
                            href={`/account/applications/${app.id}`}
                            data-testid={`application-card-${app.id}`}
                            className="group grid grid-cols-[1fr_auto] items-center gap-x-6 gap-y-1 border-t border-ink/10 px-2 py-5 transition-colors hover:bg-sand lg:grid-cols-[1fr_auto_auto_auto]"
                        >
                            <span className="min-w-0">
                                <span className="block truncate font-serif text-lg font-medium tracking-tight text-ink group-hover:text-forest">
                                    {app.job_title}
                                </span>
                                <span className="block truncate text-xs text-ink/50">
                                    {app.job_company}{app.job_country ? ` · ${app.job_country}` : ""} · Ref {app.reference} · Applied {formatDate(app.created_at)} · Updated {formatDate(app.updated_at)}
                                </span>
                            </span>
                            <StatusPill status={app.status} />
                            <span className="hidden text-xs text-ink/45 lg:block">{formatDate(app.updated_at)}</span>
                            <ArrowUpRight size={16} strokeWidth={1.5} className="hidden text-forest opacity-0 transition-opacity group-hover:opacity-100 lg:block" />
                        </a>
                    ))}
                    <div className="border-t border-ink/10" />
                </div>
            )}
        </AccountLayout>
    );
}
